module.exports = __webpack_public_path__ + "media/images/icons/mp-symbol-0df2f48a953d7a7cd5336f68d364b58c.svg";